<template>
	<v-card class="opaqueBg02 my-2" rounded>
		<v-card-text>
			<h2 class="text-h4">News Section</h2>
		</v-card-text>
		<v-card-text class="pt-0">
			<v-card outlined>
				<v-card-text class='pt-0'>
					<v-row no-gutters>
						<v-col cols="12">
							<span class="overline">Add</span>
						</v-col>

						<NewCard title="News Entry" @click='newItem("LOCAL")' color="primary" dark />
						<NewCard class='px-1' title="LinkedIn Post" @click='newItem("LINKED_IN")' color="secondary" dark />
						<NewCard title="Link to Article" color="green darken-1" @click='newItem("EXTERNAL")' dark />
					</v-row>
				</v-card-text>
			</v-card>

			<v-card class="opaqueBg">
				<h4 class="ml-4 overline">
					News entries <small>Click to edit</small>
				</h4>
				<Collection
					cols="12"
					:collection="news"
					:form="formComponent"
					@change="$emit('change')"
					dialogWidth="1000"
					title="News Entry"
					breakpoints="xs12"
					disableNew
					hideHelp
					pushToTop
					max-width="100%"
					ref='newsCollection'
				>
					<NewsItem
						adminMode
						disableClick
						slot-scope="{ item }"
						v-bind="item"
						v-if='item.type == "LOCAL"'
						
					/>
					<NewsItemLink
						adminMode
						disableClick
						slot-scope="{ item }"
						v-bind="item"
						v-else
					/>
				</Collection>
			</v-card>
		</v-card-text>
	</v-card>
</template>

<script>
import NewsScraper from '@/components/admin/NewsScraper'
import Collection from '@/components/admin/ItemCollection'
import NewsItem from '@/components/n-collections/n-items/NewsItem'
import NewsItemLink from '@/components/n-collections/n-items/NewsItemLink'

import NewCard from '@/components/ui/NewCard'

import NewsForm from '@/components/dialogs/forms/NewsForm'
import LinkedInForm from '@/components/dialogs/forms/NewsFormLinkedIn'
import ExternalForm from '@/components/dialogs/forms/NewsFormExternal'

export default {
	name: 'NewsAdministration',
	NewsForm,
	LinkedInForm,
	components: {
		Collection,
		NewsItem,
		NewsItemLink,
		NewCard,
		NewsScraper
	},
	data() {
		return {
			formComponent: NewsForm
		}
	},
	props: {
		news: Array
	},
	methods: {
		async newItem(type) {
			switch(type) {
				case 'LOCAL':
					this.formComponent = NewsForm
					break
				case 'LINKED_IN':
					this.formComponent = LinkedInForm
					break
				case 'EXTERNAL':
					this.formComponent = ExternalForm
					break
			}

			// Give Vue time to update form component
			await this.$nextTick()

			const newItem = { URL: '', title: '', type }
			this.$refs.newsCollection.view(newItem)
		}	
	},
}
</script>

<style lang="scss" scoped>
</style>